import type { ItemList, WithContext } from 'schema-dts';
import { schemaAbsoluteUrl } from '@/shared/lib/utils/schema-ids';

const SITE_NAVIGATION_ITEMS = [
    { name: 'Регистрация', path: '/registration/' },
    { name: 'Приложение TNF', path: '/application/' },
    { name: 'Forum', path: '/participation/participants/' },
    { name: 'Expo', path: '/participation/visitors/' },
    { name: 'Выставка', path: '/expo/' },
    { name: 'Новости', path: '/news/' },
] as const;

export function generateSiteNavigationJsonLd(): WithContext<ItemList> {
    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: 'Основная навигация',
        itemListElement: SITE_NAVIGATION_ITEMS.map((item, index) => ({
            '@type': 'SiteNavigationElement',
            position: index + 1,
            name: item.name,
            url: schemaAbsoluteUrl(item.path),
        })),
    };
}
